export default __webpack_public_path__ + "static/media/michaela.020066bf.png";